import UploadDocumentsContainer from './upload-documents-container';

export default UploadDocumentsContainer;